export default "__VITE_ASSET__9975c5c2__"